import { useTranslation } from 'next-i18next';
import React from 'react';

import LeadButton from '@/components/LeadButton';
import TrustpilotBar from '@/components/TrustpilotBar';

const Trustpilot: React.FC = () => {
  const { t } = useTranslation(['home']);

  return (
    <div className="mt-[40px] flex flex-col items-center xl:mt-[60px]">
      <div className=" z-10 text-center lg:text-left">
        <LeadButton
          theme="colorfulBorder"
          size="xl"
          traceName="O_WhyWuKong_FirstModule_CTAClick"
          traceGa4Name="new_entry_How_FirstModuleCTA">
          {t('banner-按钮')}
        </LeadButton>
      </div>
      <div className="mt-[20px] lg:mt-[28px] xl:mt-[32px] lg:[&_a]:justify-start">
        <TrustpilotBar />
      </div>
    </div>
  );
};

export default Trustpilot;
